var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-card',_vm._g(_vm._b({staticClass:"mx-3",attrs:{"to":{
    name: 'Project',
    params: { project: 'lorem-ipsum' }
  }}},'base-card',_vm.$attrs,false),_vm.$listeners),[(_vm.src)?_c('base-img',{attrs:{"aspect-ratio":1.4,"src":_vm.src,"height":"inherit"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }